export default __webpack_public_path__ + "static/media/lock.ab64faca.svg";